/**
 * Swap component
 * --------------
 */

/* Imports */

import React, { useLayoutEffect, useRef } from "react";
import globals from "../../base/variables";
import { SwapWrapper, SwapBase, SwapItem, SwapA } from "./styles.module.scss";
import { subscribe } from "../../../../utils/pub-sub";

/* Component */

const SwapComponent = ({ words, classes }) => {
  const swapEl = useRef(null);
  const interval = 3000;

  /* Animate letters */

  useLayoutEffect(() => {
    if (swapEl.current && !globals.reduceMotion) {
      const { children } = swapEl.current;
      const lastIndex = children.length - 1;

      let int = 0;
      let current = 0;
      let requestId;
      let start;

      const swapy = (timestamp) => {
        if (start === undefined) start = timestamp;

        const elapsed = timestamp - start;

        if (Math.round(elapsed) >= int) {
          const last = current;

          current += 1;

          if (current > lastIndex) current = 0;

          children[last].setAttribute("data-swap", false);
          children[current].setAttribute("data-swap", true);

          start = timestamp;
        }

        if (!int) int = interval;

        requestId = window.requestAnimationFrame(swapy);
      };

      if (globals.swap) {
        requestId = window.requestAnimationFrame(swapy);
      } else {
        subscribe("lc-swap", () => {
          requestId = window.requestAnimationFrame(swapy);
        });
      }

      document.addEventListener(
        "visibilitychange",
        () => {
          if (document.hidden) {
            if (requestId) {
              window.cancelAnimationFrame(requestId);
              requestId = false;
              start = undefined;
            }
          } else {
            requestId = window.requestAnimationFrame(swapy);
          }
        },
        false
      );
    }
  }, []);

  /* Break up words into letters */

  const getItem = (word = "", base = false) => {
    let letters = word.split("");
    let d = 0;

    letters = letters.map((l, i) => {
      const output = (
        <div
          key={`sa-${i}-${l}`}
          className={`${SwapA} lc-swap__a`}
          style={{ "--delay": `${d}ms` }}
        >
          {l}
        </div>
      );

      d += 25;

      return output;
    });

    if (base) {
      return (
        <div className={`${SwapBase} lc-swap__base lc-flex`} data-swap="true">
          {letters}
        </div>
      );
    }
    return <div className={`${SwapItem} lc-swap__item l-flex`}>{letters}</div>;
  };

  return (
    <div
      ref={swapEl}
      className={`lc-swap lc-line__display lc-ff-display p-relative o-hidden lc-fade d-inline-block ${SwapWrapper} ${classes}`}
      style={{ "--delay": "600ms" }}
    >
      {words.map((w) => {
        return getItem(w.word, w.base);
      })}
    </div>
  );
};

/* Export */

export default SwapComponent;
